module.exports = __webpack_public_path__ + "img/icon@2x(4).d5c04f38.png";